import * as React from "react";

import { ReactLightBoxGallery } from "components/LightBox/react-lightbox-gallery";
import MuiClickable from "components/MuiExtras/MuiClickable";
import { FileGetDto } from "models/ApiModels";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    lighBoxOpen: boolean;
}

interface IProps {
    thumbnail: FileGetDto | string;
    image: FileGetDto | string;
    width?: number | string;
    height?: number | string;
}

/////////////////////////////////////////////////////////////////////////////////////

class ImageZoom extends React.PureComponent<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = { lighBoxOpen: false };
    }

    public render() {
        const { image, thumbnail, width, height } = this.props;
        const img = image["url"] || image;
        const thumb = thumbnail["url"] || thumbnail;
        const zoomable = img != null;

        return thumbnail == null
            ? null
            : (
                <>
                    <MuiClickable
                        pointer="zoomIn"
                        disabled={!zoomable}
                        onClick={() => this.setState({ lighBoxOpen: true })}
                    >
                        <img
                            src={thumb}
                            alt=""
                            width={width}
                            height={height}
                            style={{ cursor: zoomable ? "zoom-in" : "pointer" }}
                        />
                    </MuiClickable>

                    {
                        zoomable &&
                        <ReactLightBoxGallery
                            index={0}
                            images={[img]}
                            thumbnails={[thumb]}
                            isOpen={this.state.lighBoxOpen}
                            onClose={() => this.setState({ lighBoxOpen: false })}
                        />
                    }
                </>
            );
    }
}

export default ImageZoom;
